import React from "react";
import { Container, Title, Image, Content, Wrapper } from "./CertifiedElements";
import jona from "../../images/ct-jona.PNG";
import { animationVariants } from "../../constants/animationVariants";

const Certified = () => {
  return (
    <Container   initial="initial"
    whileInView="animate"
    viewport={{ once: true, amount: 0.2 }}
    transition={{ staggerChildren: 0.2 }}>
      <Title variants={animationVariants.fadeIn}> Mis certificados </Title>
      <Content>
        <Wrapper
          initial="initial"
          whileInView="animate"
          viewport={{ once: true, amount: 0.2 }}
          transition={{ staggerChildren: 0.2 }}
        >          
          <Image
            src={jona}
            alt="jonaochoa"
            variants={animationVariants.fadeLeft}
          />
        </Wrapper>
      </Content>
    </Container>
  );
};

export default Certified;
